<template>
    <div>
        <div class="row">
            <div class="col-sm-8 explain_big">
                <div class="position-fixed">
                    <div class="back">
                        <a href="/menu"><img src="/static/tutorial/back.png" alt=""></a>
                    </div>
                    <div class="nav">
                        <nav class="navbar navbar-expand-lg text-center" style="background-color:#F0F0F0; border:#A0A0A0 solid 1px; padding:10px; font-size:0.8rem; color:black;">
                            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                                <ul class="navbar-nav">
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[1].img" alt="" @click="indexChange(1)"><br>{{this.EventBus.getText("advanced_menu_offset")}}</a>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[2].img" alt="" @click="indexChange(2)"><br>{{this.EventBus.getText("advanced_menu_gear")}}</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[3].img" alt="" @click="indexChange(3)"><br>{{this.EventBus.getText("advanced_menu_matchingGear")}}</a>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[4].img" alt="" @click="indexChange(4)"><br>{{this.EventBus.getText("advanced_menu_template")}}</a>
                                    </li>


                                </ul>
                            </div>
                        </nav>
                    </div>
                    <img :src=datas[index].img alt="" style="height:100px">
                    <h1>{{datas[index].subject}}</h1>
                    <div class="explain_detail">
                        <p>{{datas[index].explain[0].ex1}}</p>
                        <p>{{datas[index].explain[0].ex2}}</p>
                        <div class="explain_order ml-2 ">
                            <p>{{datas[index].explain[0].ex3}}</p>
                            <p>{{datas[index].explain[0].ex4}}</p>
                            <p>{{datas[index].explain[0].ex5}}</p>
                            <p>{{datas[index].explain[0].ex6}}</p>
                        </div>
                    </div>
                    <div class="explain_button pt-5">
                        <button @click="prevButton()" :disabled='index == 0'>{{this.EventBus.getSystemText("previous")}}</button>
                        <button @click="nextButton()" :disabled='index == datas.length -1'>{{this.EventBus.getSystemText("next")}}</button>
                    </div>
                </div>

            </div>
            <div class="col-sm-4 explain_img">
                <div class="img_list " v-for="data in 7" v-bind:key="data.index">
                    <img :src="datas[index].imgex[data-1]" alt="" style="width:100%">
                </div>
            </div>
        </div>
        
        <js/>
    </div>
</template>


<script>
import Advanced from '../../assets/language/advanced.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(Advanced);
    },
    created() {
        this.push(this.index);
    },
    data() {
        return {
            subject: undefined,
            img: undefined,
            explain: [],
            index: 0,
            datas: [
                {
                    index: 0,
                    img: ' ',
                    subject:this.EventBus.getText("advanced_advanced"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("advanced_advanced_ex"), 
                            },
                        ],
                    imgex: ['']
                },
                {
                    index: 1,
                    img: '/static/tutorial/5. 고급/1. 폰트 오프셋.png',
                    subject:this.EventBus.getText("advanced_offset"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("advanced_offset_ex1"), 
                                ex2: this.EventBus.getText("advanced_offset_ex2"), 
                                ex3: this.EventBus.getText("advanced_offset_ex3"), 
                                ex4: this.EventBus.getText("advanced_offset_ex4"),
                                ex5: this.EventBus.getText("advanced_offset_ex5"), 
                            },
                        ],
                    imgex: ['/static/tutorial/5. 고급/캡쳐/고급_0011_폰트오프셋-선택.png', 
                    '/static/tutorial/5. 고급/캡쳐/고급_0010_폰트오프셋-적용.png']
                },
                {
                    index: 2,
                    img: '/static/tutorial/5. 고급/2. 톱니 만들기.png',
                    subject:this.EventBus.getText("advanced_gear"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("advanced_gear_ex1"), 
                                ex2: this.EventBus.getText("advanced_gear_ex2"), 
                            },
                        ],
                    imgex: ['/static/tutorial/5. 고급/캡쳐/고급_0009_톱니만들기-적용.png'] 
                },
                {
                    index: 3,
                    img: '/static/tutorial/5. 고급/3. 맞물리는 톱니.png',
                    subject:this.EventBus.getText("advanced_matchingGear"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("advanced_matchingGear_ex1"), 
                                ex2: this.EventBus.getText("advanced_matchingGear_ex2"), 
                                ex3: this.EventBus.getText("advanced_matchingGear_ex3"), 
                                ex4: this.EventBus.getText("advanced_matchingGear_ex4"),
                                ex5: this.EventBus.getText("advanced_matchingGear_ex5"), 
                            },
                        ],
                    imgex: ['/static/tutorial/5. 고급/캡쳐/고급_0008_맞물리는톱니-선택.png', 
                    '/static/tutorial/5. 고급/캡쳐/고급_0007_맞물리는톱니-선택2.png', 
                    '/static/tutorial/5. 고급/캡쳐/고급_0006_맞물리는톱니-적용.png'] 
                },
                {
                    index: 4,
                    img: '/static/tutorial/5. 고급/10. 템플릿.png',
                    subject:this.EventBus.getText("advanced_template"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("advanced_template_ex1"), 
                                ex2: this.EventBus.getText("advanced_template_ex2"), 
                                ex3: this.EventBus.getText("advanced_template_ex3"), 
                                ex4: this.EventBus.getText("advanced_template_ex4"),
                                ex5: this.EventBus.getText("advanced_template_ex5"), 
                                ex6: this.EventBus.getText("advanced_template_ex6"),
                                ex7: this.EventBus.getText("advanced_template_ex7"),
                            },
                        ],
                    imgex: ['/static/tutorial/5. 고급/캡쳐/고급_0005_템플릿-선택.png',
                    '/static/tutorial/5. 고급/캡쳐/고급_0004_2D템플릿-선택.png',
                    '/static/tutorial/5. 고급/캡쳐/고급_0003_2D템플릿-선택2.png',
                    '/static/tutorial/5. 고급/캡쳐/고급_0002_2D템플릿-적용.png',
                    '/static/tutorial/5. 고급/캡쳐/고급_0001_3D템플릿-선택.png',
                    '/static/tutorial/5. 고급/캡쳐/고급_0000_3D템플릿-적용.png'] 
                }, 
                
            ]
        } 
    },
    
    methods: {
        nextButton() {
            this.index = this.index + 1;
            window.scrollTo(0,0);
        },
        prevButton() {
            this.index = this.index - 1;
            window.scrollTo(0,0);
        },
        push(index) {
            this.subject =  this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = [this.datas[index].explain[index].ex1, this.datas[index].explain[index].ex2, this.datas[index].explain[index].ex3, this.datas[index].explain[index].ex4, this.datas[index].explain[index].ex5, this.datas[index].explain[index].ex6]
            this.imgex = this.datas[index].imgex
        
        },
        indexChange(index){
            this.index = index;
            window.scrollTo(0,0);
        },
        myFunction() {
            document.getElementById("myDropdown").classList.toggle("show");
        },
        myFunction2() {
            document.getElementById("myDropdown2").classList.toggle("show");
        } 
    }
    
}
</script>

<style scoped>
    
    p {
        color: black;
    }
    .explain_big {
        padding: 0 12vw;
        margin-top: 8vw;
        float: left;
    }

    h1 {
        font-size: 25px;
        color: black;
        font-weight: 700;

    }

    .explain_detail p{
        padding: 0px;
        margin: 0px;

    }

    .explain_order p{
        margin: 0px;
        padding: 0px;
    }

    button{
        border-radius: 30px;
        padding: 3px 30px;
        margin: 10px;
        border-color: lightgray;
        border-style: solid;
        background-color: white;
        font-size: 0.8rem;
        outline: 0;
    }
    .explain_img {
        right: 0;
        width: 100%;
        padding-top: 150px;
        /* background-color: white; */
    }
    .img_list {
        float: right;
    }
    .back img{
        margin-left: -100px;
        width: 35px;
        height: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    
    .navBar img{
        display: flex;
        width: 100%;
        height: auto;
    }
    .nav-item{
        display: block;
        cursor: pointer;
    }

    .nav-item img{
        width: 35px;
        height: 35px;
        margin-bottom: 0.3vw;
    }

    .dropdown-menu img{
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    .dropdown-menu a{
        font-size: 15px;
    }
    .nav{
        margin-bottom: 6vw;
    }
    a { color: inherit; } 

    .hvr-grow {
        margin: 8px;
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        }
        .hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
        -webkit-transform: scale(1.1);
        transform: scale(1.2);
        }
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_menu/advanced_menu.vue